import { useSite } from "@/context/SiteContext";

export const SampleBadge = ({ className = "" }) => {
  const { site } = useSite();
  if (!site?.pricing?.is_sample) return null;
  return (
    <span className={`inline-block align-middle ml-1 text-[10px] uppercase tracking-wider bg-[hsl(35_80%_90%)] text-[hsl(30_60%_30%)] px-2 py-0.5 rounded-full ${className}`} data-testid="sample-rate-badge">
      Sample rate, demonstration only
    </span>
  );
};
